<template>
  <div class="rating">
    <Header>
      <div class="rating-header__block">
        <UiSelect
          id="course-stream"
          class="rating-header__item -m-"
          title="Выбор курса"
          placeholder="Ничего не выбрано"
          :option="courseList"
          :value="filter.course === '' ? filter.stream : filter.course"
          :show-grouped="true"
          :select-groups="filter.stream === ''"
          :can-unset="true"
          @input="filterByStream($event)"
          @group-input="filterByCourse($event)"
        />
        <UiNestedFilter
          v-if="filter.stream && facultyList.length > 0"
          id="faculty"
          class="rating-header__item -m-"
          title="Выбор сборной"
          placeholder="Выберите из списка"
          :option="facultyList"
          :value="filter.faculty"
          @input="filterByFaculty($event)"
        />
        <UiNestedFilter
          v-if="filter.stream && tariffList.length > 0"
          id="tariff"
          class="rating-header__item -m-"
          title="Выбор тарифа"
          placeholder="Выберите из списка"
          :option="tariffList"
          :value="filter.tariff"
          @input="filterByTariff($event)"
        />
        <UiNestedFilter
          v-if="filter.stream && segmentList.length > 0"
          id="segment"
          class="rating-header__item -m-"
          title="Выбор сегмента"
          placeholder="Выберите из списка"
          :option="segmentList"
          :value="filter.segment"
          @input="filterBySegment($event)"
        />
        <UiInput
          v-model="filter.userName"
          class="rating-header__item -l-"
          title="Найти участника"
          icon="ui-search"
          placeholder="Введите имя участника"
          @input="changeValueDebounced($event, 'q')"
        />
      </div>
      <div class="rating-header__block">
        <UiDateInput
          class="rating-header__item -s- -background-main-"
          :value="filter.dateStart"
          title="Выберите дату"
          placeholder="От"
          icon="ui-calendar"
          icon-class="rating-icon -calendar-"
          size-class="-s-"
          :default-now="false"
          :disabled-days="dateDisabled"
          :clearable="true"
          @input="startDateChanged($event)"
        />
        <UiDateInput
          class="rating-header__item -s- -background-main-"
          :value="filter.dateEnd"
          title="Выберите дату"
          placeholder="До"
          icon="ui-calendar"
          icon-class="rating-icon -calendar-"
          size-class="-s-"
          :default-now="false"
          :disabled-days="dateDisabled"
          :clearable="true"
          @input="endDateChanged($event)"
        />
        <!-- Оставлено до лучших времен
        <UiButton
          v-else="v-else"
          class="-transparent-blue- rating-header__item"
          @click="openModal"
        >
          <Icon
            class="rating-header__icon"
            icon="ui-export"
          />Экспорт CSV
        </UiButton>
        -->
      </div>
    </Header>
    <UnifiedTable
      :sort-chanel="filter.sort.order"
      :nav-titles="navTitles"
      @setSort="setSort"
    />
    <!-- Оставлено до лучших времен
    <CsvModal
      v-if="isAdmin"
      v-model="isShowModal"
      :group-id="filter.course"
    />
    -->
  </div>
</template>

<script>
import Header from '@/views/Rating/components/Header';
import UnifiedTable from './components/UnifiedTable';
import UiDateInput from '@/components/UiKit/DateInput';
import UiSelect from '@/components/UiKit/Select';
import UiNestedFilter from '@/components/UiKit/NestedFilter';
import UiInput from '@/components/UiKit/Input';
// import CsvModal from "@/views/Rating/Hundred/components/CsvModal";
import { mapGetters, mapState } from 'vuex';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'UnifiedGlobal',
  components: {
    Header,
    UnifiedTable,
    UiDateInput,
    UiSelect,
    UiNestedFilter,
    UiInput
    // CsvModal,
  },
  data: () => ({
    isShowModal: false,
    filter: {
      userName: '',
      course: '', // курсы (1 фильтр)
      stream: '', // потоки (1 фильтр)
      faculty: [], // факультеты (2 фильтр)
      tariff: [], // тариф (3 фильтр)
      segment: [], // сегмент (4 фильтр)
      dateStart: '',
      dateEnd: '',
      sort: {
        order: null,
        // 0 - DESC; 1 - ASC
        reversed: null
      }
    },
    navTitles: [
      {
        title: 'Имя',
        id: 1,
        width: '2fr'
      },
      {
        title: 'Ниша',
        id: 2,
        width: '1fr'
      },
      {
        title: 'Выручка',
        id: 3,
        width: '1fr',

        order: 'revenue',
        reversed: 0
      },
      {
        title: 'Прибыль',
        id: 4,
        width: '1fr',

        order: 'profit',
        reversed: 0
      }
    ]
  }),
  computed: {
    ...mapGetters('ratingUnifiedGlobal', {
      courseList: 'courseList',
      facultyList: 'facultyList',
      tariffList: 'tariffList',
      segmentList: 'segmentList'
    }),
    ...mapState('ratingUnifiedGlobal', {
      // Фильтр со вложенностью
      // folders : s => s.data.folders.map(item=> ({
      //   title: item.folder.name[0][0], //Убрать массивы
      //   id: item.folder.id,
      //   list: item.groupArray.map(({id, name})=> ({title: name, id}))
      // }))
    }),
    ...mapState('auth', {
      isAdmin: s => s.data.user.permissions.isAdmin,
      user: s => s.data.user,
      isLoadingUser: s => s.meta.loading
    })
  },
  watch: {
    '$route.query'() {
      this.getUserList();
    }
  },
  created() {
    this.initFilter();
  },
  mounted() {
    this.getCourse();
    this.getUserList();
  },
  destroyed() {
    this.$store.dispatch('ratingUnifiedGlobal/clearUserList');
  },
  methods: {
    initFilter() {
      const query = this.$route.query;
      const filter = this.filter;

      filter.userName = query['name'] || filter.userName;
      filter.course = +query['groupIds'] || filter.course;
      filter.stream = query['stream'] || filter.stream;
      filter.dateStart = query['date_start'] || filter.dateStart;
      filter.dateEnd = query['date_end'] || filter.dateEnd;

      filter.sort.order = query['order'] || filter.order;
      filter.sort.reversed = query['reversed'] || filter.reversed;

      if (query['order'] !== undefined && query['reversed'] !== undefined) {
        this.changeSort({
          order: +query['order'],
          reversed: +query['reversed']
        });
      }
    },
    filterByCourse(value) {
      if (this.filter.course !== value) {
        this.filter.course = value;
        this.filter.stream = '';
        this.filter.faculty = [];
        this.filter.tariff = [];
        this.filter.segment = [];
        this.multipleChangeValue({
          course: this.filter.course,
          stream: '',
          'faculties[]': '',
          'tariffs[]': '',
          'segments[]': ''
        });
      }
    },
    filterByStream(value) {
      if (this.filter.stream !== value) {
        this.filter.course = '';
        this.filter.stream = value;
        this.filter.faculty = [];
        this.filter.tariff = [];
        this.filter.segment = [];
        this.multipleChangeValue({
          course: '',
          stream: this.filter.stream,
          'faculties[]': '',
          'tariffs[]': '',
          'segments[]': ''
        });
        this.getOtherFilters();
      }
    },
    filterByFaculty(array) {
      this.filter.faculty = array;
      this.multipleChangeValue({
        'faculties[]': array.length ? this.filter.faculty : ''
      });
    },
    filterByTariff(array) {
      this.filter.tariff = array;
      this.multipleChangeValue({
        'tariffs[]': array.length ? this.filter.tariff : ''
      });
    },
    filterBySegment(array) {
      this.filter.segment = array;
      this.multipleChangeValue({
        'segments[]': array.length > 0 ? this.filter.segment : ''
      });
    },
    openUser(id) {
      this.$router.push(`/rating/unified/user/${id}`);
    },
    getCourse() {
      this.$store.dispatch('ratingUnifiedGlobal/getCourses');
    },
    getOtherFilters() {
      this.$store.dispatch(
        'ratingUnifiedGlobal/getFaculties',
        this.filter.stream
      );
      this.$store.dispatch(
        'ratingUnifiedGlobal/getTariffs',
        this.filter.stream
      );
      this.$store.dispatch(
        'ratingUnifiedGlobal/getSegments',
        this.filter.stream
      );
    },
    getUserList() {
      this.$store.dispatch('ratingUnifiedGlobal/getUserList', this.filter.sort);
    },
    changeValue(value, name) {
      const obj = {};
      obj[name] = value;

      const arrQuery = Object.entries({ ...this.$route.query, ...obj }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }

      replaceRouteQuery(arrQuery);
    },
    dateDisabled(date) {
      return moment(date).isoWeekday() !== 1;
    },
    changeValueDebounced: _.debounce(function (value, name) {
      this.changeValue(value, name);
    }, 500),
    multipleChangeValue(params) {
      const arrQuery = Object.entries({ ...this.$route.query, ...params }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }

      replaceRouteQuery(arrQuery);
    },
    checkRouterEqual(arrQuery) {
      return !arrQuery.find(
        param => param.value != this.$route.query[param.name]
      );
    },
    setSort({ order, reversed, id }) {
      if (order !== this.filter.sort.order) {
        this.changeSort({ order });
        this.multipleChangeValue({ order: order, reversed });
      } else {
        const idx = this.navTitles.findIndex(nav => nav.id === id);
        this.changeSort({ order, reversed: reversed ? 0 : 1 });
        this.multipleChangeValue({ reversed: this.navTitles[idx].reversed });
      }
    },
    startDateChanged(newDate) {
      const startOfWeek = newDate
        ? moment(newDate).startOf('week').format('YYYY-MM-DD')
        : undefined;
      this.filter.dateStart = startOfWeek;
      this.changeValue(startOfWeek, 'startDate');
    },
    endDateChanged(newDate) {
      const startOfWeek = newDate
        ? moment(newDate).startOf('week').format('YYYY-MM-DD')
        : undefined;
      this.filter.dateEnd = startOfWeek;
      this.changeValue(startOfWeek, 'endDate');
    },
    changeSort({ order, reversed }) {
      if (order !== undefined) {
        this.filter.sort.order = order;
      }

      if (order !== undefined && reversed !== undefined) {
        const idx = this.navTitles.findIndex(nav => nav.order === order);
        if (idx === -1) {
          return;
        }

        this.navTitles[idx].reversed = reversed;
        this.filter.sort.reversed;
      }
    },
    openModal() {
      this.isShowModal = true;
    }
  }
};
</script>
